import React, { Component } from 'react'

const UserContext = React.createContext()

class UserProvider extends Component {

    // Context state
    // poc/api: cookie session (HttpOnly, appka do ní nevidí) — místo clientToken
    // (JWT, dřív čitelný v JS) se persistuje jen "jsem přihlášen" příznak. Pokud
    // cookie mezitím na serveru vypršela, existující 401-handling ve
    // fetch().then() (viz Overview.js) přesměruje na /login stejně jako dřív
    // s neplatným JWT.
    state = {
        user: (sessionStorage.getItem('lakovna-user') ? JSON.parse(sessionStorage.getItem('lakovna-user')) : { loggedIn: false, userName: null, fullName: null, type: null, canEdit: false, canRevert: false }),
    }

    // Method to update state
    setUser = (user, callback = null) => {

        this.setState({ user }, () => {

            if (user && user.loggedIn) {
                sessionStorage.setItem('lakovna-user', JSON.stringify(user));
            }
            else
                sessionStorage.removeItem('lakovna-user');

            if (callback) {
                callback(); 
            }
        });

    }

    render() {
        const { children } = this.props
        const { user } = this.state
        const { setUser } = this

        return (
            <UserContext.Provider
                value={{
                    user,
                    setUser,
                }}
            >
                {children}
            </UserContext.Provider>
        )
    }
}

export default UserContext

export { UserProvider }
